// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFound-notFoundContainer-lHO5l {
    margin: 90px auto 50px;
    padding-left: 20px;
    padding-right: 20px;
    max-width: var(--max-content-width);
    min-height: 430px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.NotFound-textCenter-kQWZE {
    text-align: center;
}

.NotFound-notFoundHeading-Yhggk {
    font-size: 95px;
    line-height: normal;
    font-weight: bold;
    margin: 0;
}

.NotFound-notFoundList-ePZZb {
    padding: 0;
    list-style: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 8px;
}

.NotFound-errorCodeText-V2P32 {
    font-size: 15px;
    line-height: normal;
    font-weight: 400;
    color: var(--alert-color);
}

.NotFound-headingSubText-edDZm {
    font-size: 22px;
    font-weight: 400;
    line-height: normal;
    margin-top: 20px;
    color: var(--secondary-foreground);
}

@media (max-width:991px) {
    .NotFound-notFoundHeading-Yhggk {
        font-size: 50px;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/notFound/NotFound.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,mCAAmC;IACnC,iBAAiB;IACjB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".notFoundContainer {\n    margin: 90px auto 50px;\n    padding-left: 20px;\n    padding-right: 20px;\n    max-width: var(--max-content-width);\n    min-height: 430px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.textCenter {\n    text-align: center;\n}\n\n.notFoundHeading {\n    font-size: 95px;\n    line-height: normal;\n    font-weight: bold;\n    margin: 0;\n}\n\n.notFoundList {\n    padding: 0;\n    list-style: none;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.errorCodeText {\n    font-size: 15px;\n    line-height: normal;\n    font-weight: 400;\n    color: var(--alert-color);\n}\n\n\n.headingSubText {\n    font-size: 22px;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 20px;\n    color: var(--secondary-foreground);\n}\n\n@media (max-width:991px) {\n    .notFoundHeading {\n        font-size: 50px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notFoundContainer": `NotFound-notFoundContainer-lHO5l`,
	"textCenter": `NotFound-textCenter-kQWZE`,
	"notFoundHeading": `NotFound-notFoundHeading-Yhggk`,
	"notFoundList": `NotFound-notFoundList-ePZZb`,
	"errorCodeText": `NotFound-errorCodeText-V2P32`,
	"headingSubText": `NotFound-headingSubText-edDZm`
};
module.exports = ___CSS_LOADER_EXPORT___;
